import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from 'src/app/shared/upload.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { ParametrosUACModel } from 'src/app/models/parametrosUAC.model';
import { FuncionarioBasicoModel } from 'src/app/models/funcionario.model';

@Component({
    selector: 'cargar-foto-arl',
    templateUrl: './cargar-foto-arl.component.html',
    styleUrls: ['./cargar-foto-arl.component.scss']
})
export class CargarFotoARLComponent implements OnInit {

    @ViewChild('inputFile') inputFile: ElementRef;
    @ViewChild('labelImport')
    labelImport: ElementRef;
    accept = 'image/x-png,image/jpg,image/jpeg';
    acceptArl = ".pdf";
    nombreArchivo: string;
    fileToUpload: File;
    maxSize: number;
    cargandoArchivo: boolean;
    sinAdjunto: string;
    foto: string;
    arl: string;
    error: boolean;
    verPantalla = false;
    opcion: string;
    caracteristicasFoto: string;
    caracteristicasARL: string;
    tamanioMaxFoto: number;
    tamanioMaxARL: number;
    public parametros: ParametrosUACModel[] = [];
    tokenFoto: string;
    tokenARL: string;
    tokenInvalido = true;
    funcionario: FuncionarioBasicoModel;

    public listaParametros: string[] = [DominiosService.TAMANIO_DOCUMENTO_ARL,
    DominiosService.TAMANIO_ARCHIVO_FOTO, DominiosService.MENSAJE_CARACTERISTICA_FOTO,
    DominiosService.MENSAJE_CARACTERISTICA_ARL];


    constructor(private uploadService: UploadService, private alertService: AlertService,
        private urlService: UrlService,
        private router: Router, private route: ActivatedRoute,
        private utilService: UtilService,
        private spiner: NgxSpinnerService,
        private global: GlobalService) {
        this.sinAdjunto = ConstantesService.SIN_ADJUNTO;
        this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
        this.cargandoArchivo = false;
    }

    ngOnInit(): void {

        this.spiner.show();
        this.cargarToken();

    }

    cargarToken() {
        this.foto = this.route.snapshot.paramMap.get('tokenFoto');
        this.arl = this.route.snapshot.paramMap.get('tokenArl');
        if (this.utilService.validarCamposObligatorios(this.foto)) {
            this.opcion = "FOTO";
            this.tokenFoto = this.foto;
            this.tokenARL = "";
            this.cargarParametros();
        }
        else if (this.utilService.validarCamposObligatorios(this.arl)) {
            this.tokenARL = this.arl;
            this.opcion = "ARL";
            this.tokenFoto = "";
            this.cargarParametros();
        } else {
            this.cargueNoAutorizado();
        }

    }

    cargarParametros() {

        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postPublico(url, this.listaParametros).subscribe(
            (data: ParametrosUACModel[]) => {
                this.parametros = data;
                this.caracteristicasFoto = data.find(x => x.nombre == DominiosService.MENSAJE_CARACTERISTICA_FOTO).valor;
                this.caracteristicasARL = data.find(x => x.nombre == DominiosService.MENSAJE_CARACTERISTICA_ARL).valor;
                this.tamanioMaxARL = Number(data.find(x => x.nombre == DominiosService.TAMANIO_DOCUMENTO_ARL).valor);
                this.tamanioMaxFoto = Number(data.find(x => x.nombre == DominiosService.TAMANIO_ARCHIVO_FOTO).valor);
                this.validarTokenFuncionario();
            });
    }

    validarTokenFuncionario() {

        const serviceProvider = 'validarTokenFuncionarioCargueDocumento';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tokenFoto', this.urlService.encodeURI(this.tokenFoto)]);
        queryParams.push(['tokenARL', this.urlService.encodeURI(this.tokenARL)]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postPublico(url).subscribe(
            (data: FuncionarioBasicoModel) => {
                this.funcionario = data;
                this.spiner.hide();
                this.verPantalla = true;
                console.log("OK token");
            }, err => {
                this.spiner.hide();
                this.tokenInvalido = false;
                this.cathException(err.error.message, err);
            });

    }

    cargueNoAutorizado() {
        this.spiner.hide();
        return this.alertService.generateAlertError('El link no es válido para cargar el archivo'
            , 'Error');
    }

    /**
     * Metodo encargado de detectar el evento del componente de carga de documentos
     */
    onFileChange(event: any) {

        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            this.fileToUpload = file;
            this.validarArchivo(this.fileToUpload);
            event.target.value = '';
        }
    }


    /**
     * Realiza las validaciones de tamaño y extension del documento cargado
     */
    validarArchivo(archivo: File) {

        if (archivo) {

            if (this.opcion == 'FOTO' && !archivo.name.includes('.jpg') && !archivo.name.includes('.jpeg') &&
                !archivo.name.includes('.png')) {
                this.inputFile.nativeElement.value = '';
                return this.alertService.generateAlertError('El formato del archivo no es válido para cargar el archivo'
                    , 'Error');
            } else if (this.opcion == 'ARL' && !archivo.name.includes('.pdf')) {
                this.inputFile.nativeElement.value = '';
                return this.alertService.generateAlertError('El formato permitido para documento de ARL es PDF'
                    , 'Error');
            }
            if (archivo.size === 0) {
                this.inputFile.nativeElement.value = '';
                return this.alertService.generateAlertError('No se puede cargar el archivo porque se encuentra vacío', 'Error');
            }
            if (this.opcion == 'ARL' && archivo.size > 85000) {
                this.inputFile.nativeElement.value = '';
                return this.alertService.generateAlertError('El formato del archivo no es válido, por favor verifique', 'Error');
            }
            if (this.opcion == 'FOTO' && archivo.size > 80000) {
                this.inputFile.nativeElement.value = '';
                return this.alertService.generateAlertError('El formato del archivo no es válido, por favor verifique', 'Error');
            }
            this.uploadFiles();
            console.log("ok");
        }
    }

    /**
     * Metodo encargado de realizar la carga del documento en el gestor documental
     */
    uploadFiles() {
        this.cargandoArchivo = true;
        if (this.opcion == 'ARL') {
            this.nombreArchivo = this.funcionario.tipoIdFuncionario + this.funcionario.numeroIdFuncionario + "ARL" +
                this.fileToUpload.name;
        } else {
            this.nombreArchivo = this.funcionario.tipoIdFuncionario + this.funcionario.numeroIdFuncionario + "FOTO" +
                this.fileToUpload.name;
        }

        const formData = new FormData();
        formData.append('file', this.fileToUpload);
        return this.uploadService.cargarArchivoFotoARL(`/servicios/funcionario/cargarFotoARL?nombreArchivo=${this.nombreArchivo}`+
        `&&tipoDocumento=${this.funcionario.tipoIdFuncionario}`+`&&numeroDocumento=${this.funcionario.numeroIdFuncionario}`+
        `&&tipoFuncionario=${this.funcionario.tipoFuncionario}`, formData)
            .subscribe((data) => {

                this.cargandoArchivo = false;
                this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
                this.alertService.generateAlertSuccess('Carga completa', ' ');
                this.tokenFoto="";
                this.tokenARL="";
                

            }, error => {
                this.cargandoArchivo = false;
                this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
                this.alertService.generateAlertError(error.error.message, ' ');
            });
    }

    cerrarPestana() {
        var customWindow = window.open('', '_self', '');
        customWindow.close();
    }


    /**
     * Catch que genera una alaerta ene le componente cuando hay errores
     * @param err 
     * @author fromero
     */
    cathException(err, error) {
        console.log(error);
        this.spiner.hide();
        this.alertService.generateAlertError(err, '');
    }

}